<template>
	<div style="min-height: 70vh; max-height: 80vh; overflow: auto">
		<vx-card
			:title="
				companyConfig.type_config_id == selectedTypeConfig.id
					? $t('CompanyConfigCrudFormTitleEdit')
					: $t('CompanyConfigCrudFormTitleCreate')
			"
			class="mt-5"
			:cardBorder="true"
			:noShadow="true"
		>
			<template slot="actions">
				<div class="flex flex-row justify-between">
					<transition name="fade">
						<vx-tooltip delay=".1s" :text="$t('Crud.Delete')">
							<vs-button
								v-show="selectedTypeConfig.name === 'VISUAL_CONFIG' && isGotu"
								color="dark"
								class="mb-2 mr-2"
								@click="selectedTypeConfig = {}"
								icon-pack="feather"
								icon="icon-x"
								type="flat"
								>{{ $t("Cancel") }}
							</vs-button>
						</vx-tooltip>
					</transition>
					<transition name="fade">
						<vx-tooltip delay=".1s" :text="$t('Crud.Delete')">
							<vs-button
								color="danger"
								class="mr-3 mb-2"
								icon-pack="feather"
								icon="icon-trash-2"
								type="flat"
								radius
								@click="openConfirm"
								v-if="companyConfig.type_config_id == selectedTypeConfig.id && isGotu"
							></vs-button>
						</vx-tooltip>
					</transition>
					<transition name="fade">
						<vx-tooltip delay=".1s" :text="$t('Save')">
							<vs-button
								id="btn-submit-company"
								color="dark"
								class="mb-2"
								@click="getDataTrigger += 1"
								icon-pack="feather"
								icon="icon-save"
								type="flat"
								>{{ $t("Save") }}
							</vs-button>
						</vx-tooltip>
					</transition>
				</div>
			</template>

			<vs-row vs-w="12">
				<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
					<div class="vx-row mb-6">
						<div class="vx-col w-full md:w-2/2 mb-base">
							<v-select
								name="status"
								:clearable="false"
								:options="listTypeConfig"
								v-model="selectedTypeConfig"
								value="id"
								label="name"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								:disabled="companyConfig.type_config_id == selectedTypeConfig.id || !isGotu"
								:getOptionLabel="(user) => user.name"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
									<template v-else>
										{{ $t("NoResultsFound") }}
									</template>
								</template>
							</v-select>
						</div>
					</div>

					<dynamic-setting-form
						v-if="json_properties.length > 0"
						:json_properties="json_properties"
						:config_json="config_json"
						:getDataTrigger="getDataTrigger"
						:typeConfigName="selectedTypeConfig.name"
						@saveEmit="createCompanySetting"
						@updateEmit="updateCompanySetting"
						:companyId="companyId"
					></dynamic-setting-form>
				</vs-col>
			</vs-row>
		</vx-card>
	</div>
</template>
<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";
import {Validator} from "vee-validate";
import {dict} from "@/models/CompanyConfValidator.js";
import Company from "@/models/CompanyConf.js";
import moduleCompanyConfigCrud from "@/store/company-config-crud/moduleCompanyConfigCrud.js";
import DynamicSettingForm from "./DynamicSettingForm.vue";
import messagesValidator from "../../helpers/messagesValidator";

// register custom messages
Validator.localize("en", dict);

export default {
	name: "CompanyForm",
	components: {
		Datepicker,
		vSelect,
		DynamicSettingForm,
	},
	props: {
		data: Object,
		companyId: {
			type: Number,
			default: 0,
		},
		changeColorTriger: {
			type: Object,
		},
		changeLogoTriger: {
			type: Object,
		},
		isGotu: {
			type: Boolean,
			default: false,
		},
		update: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			companyConfig: JSON.parse(JSON.stringify(this.data)),
			config_json: {},
			json_properties: [],
			langEs: es,
			langEn: en,
			selectedTypeConfig: {},
			configSelected: {},
			itemsSelected: {},
			getDataTrigger: 0,
		};
	},
	computed: {
		listConfig() {
			return this.$store.state.moduleCompanyConfigCrud.companies;
		},
		listTypeConfig() {
			return this.$store.state.moduleCompanyConfigCrud.config_list.filter(
				(j) => !this.listConfig.some((l) => l.type_config_name === j.name)
			);
		},
	},
	methods: {
		createCompanySetting(data) {
			this.itemsSelected = {...data};
			this.createCompanyConfig();
		},
		updateCompanySetting(data) {
			this.itemsSelected = {...data};
			this.updateCompanyConfig();
		},
		// Crea la configuración de compañia
		createCompanyConfig() {
			let payload = {};
			payload.type_config_id = this.selectedTypeConfig.id;
			payload.config_json = {...this.itemsSelected};
			if (this.companyId) {
				payload["company_id"] = parseInt(this.companyId);
			}
			this.$vs.loading();
			this.$store
				.dispatch("moduleCompanyConfigCrud/addCompanyConfig", payload)
				.then((res) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyConfigCreate"),
						text: this.$t("TextConfirmCompanyConfigCreate"),
					});
					this.$emit("updateCompanyConfigEmit");
				})
				.catch((err) => {
					this.$vs.loading.close();
					messagesValidator.manageError.call(this, err);
					console.error(err);
				});
		},
		// Actualiza la configuración de compañia
		updateCompanyConfig() {
			let payload = {};
			payload.type_config_id = this.selectedTypeConfig.id;
			payload.config_json = {...this.itemsSelected};
			payload.id = this.companyConfig.id;

			const userInfo = JSON.parse(localStorage.getItem("userInfo"));
			payload["company_id"] = parseInt(userInfo.serviroutes_company_id);

			if (this.companyId) {
				payload["company_id"] = parseInt(this.companyId);
			}
			this.$vs.loading();
			this.$store
				.dispatch("moduleCompanyConfigCrud/updateCompanyConfig", payload)
				.then((res) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyConfigUpdate"),
						text: this.$t("TextConfirmCompanyConfigUpdate"),
					});
					this.consultListConfig();
				})
				.catch((err) => {
					this.$vs.loading.close();
					messagesValidator.manageError.call(this, err);
					console.error(err);
				});
		},
		// Cancela la edicion
		cancelEdit() {
			this.$emit("changeActiveTabEmit", 0);
			this.company = new Company({});
			this.configSelected = {};
			this.itemsSelected = null;
			this.selectedTypeConfig = {};
		},
		loading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		consultListConfig() {
			this.loading();
			this.$store
				.dispatch("moduleCompanyConfigCrud/getListConfig")
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		consultOnlyCompanyConfig() {
			this.loading();
			this.$store
				.dispatch("moduleCompanyConfigCrud/getOnlyConfig", this.companyConfig.type_config_id)
				.then((res) => {
					this.closeLoading();
					this.selectedTypeConfig = res.data;
					this.itemsSelected = {...this.selectedTypeConfig.json_base};
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		setColorProperties(color) {
			Object.assign(this.itemsSelected, color);
		},
		// Pregunta si desea eliminar la configuración de compañia
		openConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("DeleteCompanyConf"),
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
				accept: this.acceptAlert,
			});
		},
		// Confirma la eliminación
		acceptAlert() {
			this.$emit("deleteConfigEmit", this.companyConfig);
		},
	},
	watch: {
		selectedTypeConfig(object) {
			this.json_properties = [];
			setTimeout(() => {
				this.json_properties = object.json_properties ? object.json_properties : [];
				this.$route.params.config_type = "LIST";
				this.$emit("typeConfigSelectedEmit", object);
			}, 100);
		},
		changeColorTriger(first) {
			this.itemsSelected = {...this.itemsSelected, ...first};
		},
		changeLogoTriger(val) {
			this.itemsSelected = {...this.itemsSelected, ...val};
		},
		// Este observador funciona solo cuando la confiegracion en pantalla es de tipo ON_DEMAND
		"itemsSelected.automatic_assignment"(val) {
			if (val) {
				this.itemsSelected.notify_on_create = false;
			}
		},
		// Este observador funciona solo cuando la confiegracion en pantalla es de tipo ON_DEMAND
		"itemsSelected.notify_on_create"(val) {
			if (val) {
				this.itemsSelected.automatic_assignment = false;
			}
		},
	},
	mounted() {
		setTimeout(() => {
			if (this.$route.params.config_type) {
				const foundConfig = this.listTypeConfig.find((el) => el.name === this.$route.params.config_type);
				if (foundConfig) {
					this.selectedTypeConfig = foundConfig;
				}
			}
		}, 600);
	},
	created() {
		// Registra el modulo
		if (!moduleCompanyConfigCrud.isRegistered) {
			this.$store.registerModule("moduleCompanyConfigCrud", moduleCompanyConfigCrud);
			moduleCompanyConfigCrud.isRegistered = true;
		}
		if (this.$store.state.moduleCompanyConfigCrud.config_list.length <= 0) {
			this.consultListConfig();
		}
		// Si esta modificando, mapea la información
		if (this.companyConfig.type_config_id !== 0) {
			this.config_json = this.companyConfig.config_json;
			this.consultOnlyCompanyConfig();
		} else {
			this.json_properties = [];
			this.config_json = {};
		}
	},
};
</script>
